// Hooks de conta, empresas, membros e equipe.
import { useQuery } from '@tanstack/react-query'
import type { AccountDetailDto, CompaniesResponse, CompanyTeamResponse, MembersResponse } from '@impulso/shared/api/tenancy'
import { api } from '../../lib/api'

export const useAccount = (accountId: string | undefined) =>
  useQuery({ queryKey: ['account', accountId], queryFn: () => api.get<AccountDetailDto>(`/accounts/${accountId}`), enabled: !!accountId })
export const useAccountCompanies = (accountId: string | undefined, status: 'active' | 'all' = 'all') =>
  useQuery({ queryKey: ['account-companies', accountId, status], queryFn: () => api.get<CompaniesResponse>(`/accounts/${accountId}/companies?status=${status}`), enabled: !!accountId })
export const useMembers = (accountId: string | undefined) =>
  useQuery({ queryKey: ['members', accountId], queryFn: () => api.get<MembersResponse>(`/accounts/${accountId}/members`), enabled: !!accountId })
export const useTeam = (companyId: string) =>
  useQuery({ queryKey: ['team', companyId], queryFn: () => api.get<CompanyTeamResponse>(`/companies/${companyId}/team`) })
